/* 
 * Développé par la société Précurseur.
 @copyright  Copyright (c) Précurseur
 @link       https://www.precurseur.fr
 */
import $ from 'jquery';

/**
 * Sticky scrollbar sidebar news extranet
 */
export default class SidebarNews {

    constructor() {
        this.sidebarWrapper = $('.seila-extranet__sidebar__news-wrapper');
        this.sidebarNews = $('.seila-extranet__sidebar__news');

        if (this.sidebarNews.length) {
           $(window).on("resize", this.resize.bind(this));   
           $(window).on("scroll", this.resize.bind(this));   
            this.resize();
        }
    }

    resize() {
        
        var scroll = $(window).scrollTop();
        var elementorDeviceClass = $('body').attr('data-elementor-device-mode');
        var classes = ['desktop','laptop'];
        
        var position = this.sidebarNews.offset(); 
        var windowHeight = $(window).height();
        
        if (elementorDeviceClass && classes.includes(elementorDeviceClass)) {
            var height = windowHeight - (position.top - $(document).scrollTop());        
            this.sidebarNews.height(height - 60);
            
            if (scroll > 74) {
                this.sidebarWrapper.addClass('fixed');
            } else {
                this.sidebarWrapper.removeClass('fixed');
            }
            
        } else {
            this.sidebarNews.height('auto');
            this.sidebarWrapper.removeClass('fixed');
        }
    }
};
